import {
  lowHeightScreens,
  mediumScreens,
  smallScreens,
  TicketButtonsText,
  ButtonText,
  extraSmallScreens,
} from './fontElements';
import * as colors from './colorConstants';
import styled, { css } from 'styled-components/macro';
import { panelHeaderHeight } from './layout';
import { Link } from 'react-router-dom';
import * as breakpoints from './mediaQueries';

// standard blue button used throughout platform
// for different widths - pass 'width' prop
export const CommonBlueButton = styled.button`
  margin: 0;
  outline: 0;
  font-size: 11px;
  background-color: ${colors.blue1};
  color: ${colors.whiteText};
  border: none;
  cursor: pointer;
  height: 25px;
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${(props) => (props.width ? props.width : 'auto')};

  &:disabled {
    opacity: 0.4;
  }
`;

export const ExpertToggleLockCancelButton = styled(CommonBlueButton)`
  background-color: ${colors.black4} !important;
  width: 45%;
`;

export const DismissButton = styled(CommonBlueButton)`
  background-color: ${colors.black4} !important;
  width: 25%;
`;

export const ConfirmButton = styled(CommonBlueButton)`
  width: calc(75% - 20px);
  margin-left: 20px;
`;

export const PolicyButton = styled.button`
  background-color: #44b1df;
  min-width: 8.5rem;
  border: 0 #787878;
  border-radius: 2.2rem;
  color: #ffffff;
  font-family: lato, sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.3rem;
  padding: 0.5rem 2.5rem;
  transition: 0.3s;

  &:hover {
    background-color: #545454;
  }
`;

export const Button = styled(TicketButtonsText)`
  border-radius: 4px;
  font-family: 'Lato', sans-serif;
  padding: 5px 18px;
  cursor: pointer;
  outline: 0;
  height: 25px;
  margin: 1em 5px;
  text-transform: uppercase;

  &:active,
  &:focus {
    outline: none;
  }

  &:disabled {
    opacity: 0.3;
  }
`;

export const ActionsButton = styled(Button)`
  background-color: ${(props) => (props.selected ? colors.actionButtonSelected : colors.baseBackground)};
  border: 1px solid ${colors.lightGray21};
  color: ${colors.blackText};
  transition: 0.5s;
  flex-shrink: 0;
  min-height: 23px;
`;

export const ActionsButtonsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row-reverse;
  align-items: center;
  padding-top: 10px;
  padding-bottom: 0;
  min-height: 45px;
`;

export const ActionsToggleButton = styled(ActionsButton)`
  margin: 5px;
`;

export const TicketActionButton = styled(ActionsButton)`
  display: flex;
  align-items: center;
  padding-top: 0;
  padding-bottom: 0;
  margin-top: 0 !important;
  opacity: ${(props) => (props.active ? 1 : 0.3)};
  cursor: ${(props) => (props.active ? 'cursor' : 'default')};
`;

export const DisabledActionsToggleButton = styled(ActionsToggleButton)`
  opacity: 0.3;
  cursor: default;
`;

export const FullColoredButton = styled(Button)`
  background-color: ${(props) => (props.active ? colors.blue1 : colors.fullColoredButtonBackgroundBase)};
  border: none;
  color: ${colors.whiteText};
  transition: 0.3s;
`;

export const FullColoredTicketButton = styled(FullColoredButton)`
  padding-top: 0;
  padding-bottom: 0;
  margin-top: 0 !important;
  margin-bottom: 0;
  opacity: ${(props) => (props.active ? 1 : 0.3)};
  cursor: ${(props) => (props.active ? 'cursor' : 'default')};
`;

export const CopyButton = styled(Button)`
  margin: 0px 0px 0px 10px;
  min-width: 95px;
  font-weight: 500;
  color: ${colors.copyButtonText};
  border: 1px solid ${colors.copyButtonBorder};
  background-color: ${colors.baseBackground} !important;

  @media screen and (max-width: ${mediumScreens}),
    screen and (max-height: ${lowHeightScreens}),
    screen and (max-width: ${smallScreens}) {
    margin: 0;
  }
`;

export const FeedbackButton = styled(Button)`
  background-color: ${colors.baseBackground};
  color: ${colors.copyButtonText};
  border: 1px solid ${colors.copyButtonBorder};
  display: ${(props) => (props.hide ? 'none' : 'initial')};
  margin: 0 5px;

  @media screen and (max-width: ${mediumScreens}),
    screen and (max-height: ${lowHeightScreens}),
    screen and (max-width: ${smallScreens}) {
    margin: 0 5px;
  }
`;

export const ResetAllButton = styled(ButtonText)`
  width: 100%;
  border-radius: 4px;
  height: 25px;
  background-color: ${colors.blue1};
  border: 1px solid ${colors.blue1};
  color: ${colors.whiteText};
  align-self: center;

  &:focus {
    outline: none;
  }
`;

export const DecisionTreeButton = styled.button`
  margin: 5px;
  z-index: 100;
  border: 1px solid ${colors.lightGray2};
  box-sizing: border-box;
  padding: 6px 9px;
  background-color: ${colors.baseBackground};
  color: ${colors.blackText};
  font-weight: 500;
  border-radius: 4px;
  font-family: 'Arial', sans-serif;
  font-size: 11px;
  transition: 0.5s;
  min-width: 86px;
  outline: 0;
  animation-name: fadeIn;
  animation-duration: 1s;
  animation-fill-mode: forwards;
  opacity: 0%;
  @keyframes fadeIn {
    0% {
      opacity: 0%;
    }
    100% {
      opacity: 100%;
    }
  }

  &:hover {
    border: 1px solid ${colors.blue1};
    color: ${colors.blue1};
  }

  &:active {
    border: 1px solid ${colors.blue1};
    color: ${colors.blue1};
    background-color: ${colors.blue3};
  }

  &:disabled {
    color: ${colors.lightGray1};
    border: 1px solid ${colors.lightGray1};
    &:hover {
      color: ${colors.lightGray1};
      border: 1px solid ${colors.lightGray1};
    }
  }

  @media (max-height: ${smallScreens}) {
    font-size: 10px;
    min-width: 80px;
    padding: 5px 10px;
  }

  @media (max-height: ${extraSmallScreens}) {
    font-size: 9px;
    min-width: 70px;
  }
`;

export const DeleteOrUndoButton = styled(Button)`
  background-color: ${colors.baseBackground};
  border: 1px solid ${colors.deleteOrUndoButtonBorder};
  color: ${colors.deleteOrUndoButtonText};
  border-radius: 4px;
  font-weight: 700;
`;

export const BaseSurveyButton = styled.button`
  border: none;
  cursor: ${(props) => (props.active ? 'pointer' : 'not-allowed')};
  font-size: 18px;
  text-align: center;
  background: ${(props) =>
    props.active
      ? colors.baseSurveyButtonBackground
      : `${colors.baseSurveyButtonBackground} linear-gradient(to bottom, ${colors.baseSurveyButtonGradientUp}, ${colors.baseSurveyButtonGradientDown})`};
  opacity: ${(props) => (props.active ? '1' : '0.5')};
  color: ${colors.baseBackground};

  &:hover {
    outline: none;
    text-decoration: none;
    background: ${(props) =>
      props.active
        ? colors.baseSurveyButtonHoverBackground
        : `${colors.baseSurveyButtonBackground} linear-gradient(to bottom, ${colors.baseSurveyButtonGradientUp}, ${colors.baseSurveyButtonGradientDown})`};
  }

  &:active {
    outline: none;
    text-decoration: none;
    background: ${(props) =>
      props.active
        ? colors.baseSurveyButtonActiveBackground
        : `${colors.baseSurveyButtonBackground} linear-gradient(to bottom, ${colors.baseSurveyButtonGradientUp}, ${colors.baseSurveyButtonGradientDown})`};
  }
`;

export const DisabledFullColoredButton = styled(FullColoredButton)`
  opacity: 0.3;
  cursor: default;
`;

export const DisabledActionsButton = styled(TicketActionButton)`
  opacity: 0.3;
  cursor: default;
`;

export const NoButtonPlaceholder = styled.div`
  height: 45px;
`;

export const ButtonIcon = styled.img`
  height: 7px;
  padding-right: 10px;
`;
export const InboxButtonWrapper = styled.div`
  order: 1;
  margin-right: auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  background-color: ${colors.baseBackground};
  padding-left: ${(props) => (props.removePadding ? '0px' : '30px')};
`;

export const EscalatedActionButtonHolder = styled.div`
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  flex-wrap: wrap;
  height: 45px;
  padding: 0 12px 0 60px;
  overflow: hidden;
  background-color: ${colors.baseBackground};

  @media screen and (max-width: ${mediumScreens}) {
    padding: 0 10px 0 60px;
  }

  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    padding: 0 5px 0 60px;
  }
`;

export const NextButton = styled.button`
  border: 2px solid #4a90e2;
  padding: 6px 18px;
  background-color: #4a90e2;
  color: #fff;
  font-weight: 500;
  border-radius: 4px;
  font-family: 'Arial', sans-serif;
  font-size: 9.5px;
  line-height: 1.1rem;
  height: 25px;
  -webkit-transition: 0.5s;
  transition: 0.5s;
  outline: 0;
  float: right;
  opacity: ${(props) => (props.active ? 1 : 0.4)};

  &:hover {
    border: ${(props) => (props.active ? '2px solid #4284cf' : '2px solid #4A90E2')};
    background-color: ${(props) => (props.active ? '#4284cf' : '#4A90E2')};
  }

  @media screen and (max-width: ${mediumScreens}) {
    font-size: 10px;
    padding: 6px 17px;
  }

  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    font-size: 9px;
    padding: 4px 12px;
    border: 1px solid #4a90e2;
  }
`;

export const BackButton = styled.button`
  border: 1px solid ${colors.baseText};
  padding: 6px 18px;
  background-color: ${colors.baseBackground};
  line-height: 1.1rem;
  color: ${colors.baseText};
  font-weight: 500;
  border-radius: 4px;
  font-family: 'Arial', sans-serif;
  font-size: 9.5px;
  -webkit-transition: 0.5s;
  transition: 0.5s;
  outline: 0;
  float: left;
  opacity: ${(props) => (props.disabled ? 0.4 : 1)};

  @media screen and (max-width: ${mediumScreens}) {
    font-size: 10px;
    padding: 6px 17px;
  }

  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    font-size: 9px;
    padding: 4px 12px;
  }
`;

export const ButtonsWrapper = styled.div`
  background: green !important;

  /* EscalatedActionButtonHolder */
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  flex-wrap: wrap;
  padding: 0 12px 0 60px;

  @media screen and (max-width: ${mediumScreens}) {
    padding: 0 10px 0 60px;
  }

  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    padding: 0 5px 0 60px;
  }

  /* ActionsButtonsWrapper */
  display: flex;
  flex-wrap: wrap;
  flex-direction: row-reverse;
  align-items: center;
  padding-top: 10px;
  padding-bottom: 0;
  ${panelHeaderHeight};
  @media screen and (max-width: ${mediumScreens}) {
    padding-top: 7px;
  }

  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    padding-top: 5px;
  }
`;

export const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

export const FlexRowReverse = styled.div`
  display: flex;
  flex-direction: row-reverse;
`;

export const FlexWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row-reverse;
  justify-content: flex-start;
  padding: 10px 12px 0 60px;

  @media screen and (max-width: ${mediumScreens}) {
    padding: 7px 10px 0 60px;
  }

  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    padding: 5px 5px 0 60px;
  }
`;

export const ButtonHolder = styled.div`
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
`;

export const SingleButtonHolder = styled(ButtonHolder)`
  justify-content: center;
`;

export const SecondaryButton = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 4px 10px;
  background: ${colors.baseBackground};
  border: 1px solid ${colors.lightGray21};
  border-radius: 3px;
  height: 26px;
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 11px;
  color: ${colors.lightBlack};
  min-width: 98px;
  outline: 0;
  transition: 0.5s;

  &:hover {
    border: 1px solid ${colors.blue1};
    color: ${colors.blue1};
  }

  &:active {
    border: 1px solid ${colors.blue1};
    color: ${colors.blue1};
    background-color: ${colors.blue3};
  }

  &:disabled {
    color: ${colors.lightGray1};
    border: 1px solid ${colors.lightGray1};
    &:hover {
      color: ${colors.lightGray1};
      border: 1px solid ${colors.lightGray1};
    }
  }
`;

export const TextButton = styled.button`
  background: transparent;
  border: 0;
  font: 9px 'Roboto', sans-serif;
  line-height: 14px;
  color: ${colors.purple1};
  text-decoration: underline;
  padding: 0;
  margin: 0;
`;

export const ArrowButton = styled.button`
  border: 1px solid ${colors.lightGray1};
  border-radius: 50%;
  height: 28px;
  width: 28px;
  padding: 0;
  transition: border-color 0.3s ease, opacity 0.3s ease;
  overflow: hidden;

  &:hover {
    border-color: ${colors.blue1};

    &::before {
      background-image: url('/images/new-designs/arrow-left-blue.svg');
    }
  }

  &:active {
    border-color: ${colors.activeButtonColor};

    &::before {
      background-image: url('/images/new-designs/arrow-left-dark-blue.svg');
    }
  }

  &:disabled {
    border-color: ${colors.lightGray21};
    opacity: 0.5;

    &::before {
      background-image: url('/images/new-designs/arrow-left-gray.svg');
    }
  }

  &::before {
    content: '';
    background: url('/images/new-designs/arrow-left-gray.svg') center / 8px no-repeat ${colors.baseBackground};
    display: block;
    width: 100%;
    height: 100%;
    transform: rotate(0);
  }

  &.arrow-top {
    &::before {
      transform: rotate(0.25turn);
    }
  }

  &.arrow-right {
    &::before {
      transform: rotate(0.5turn);
    }
  }

  &.arrow-bottom {
    &::before {
      transform: rotate(0.75turn);
    }
  }

  &.arrow-left {
    &::before {
      transform: rotate(0);
    }
  }
`;

export const BaseButton = styled.button`
  font-family: 'Roboto', sans-serif;
  font-size: 11px;
  line-height: 16px;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 72px;
  border: 1px solid;
  border-radius: 3px;
  transition: 200ms;

  ${(props) => {
    switch (props.$size) {
      case 'small':
        return css`
          min-height: 26px;
          padding: 5px 12px;
        `;
      case 'large':
        return css`
          min-height: 32px;
          padding: 7px 25px;
        `;
      case 'xlarge':
        return css`
          font-size: 14px;
          min-height: 40px;
          padding: 11px 25px;
        `;
      case 'medium':
      default:
        return css`
          min-height: 26px;
          padding: 4px 10px;
          gap: 5px;
        `;
    }
  }}

  & > svg {
    flex-shrink: 0;
  }
`;

export const ButtonPrimary = styled(BaseButton)`
  border: 0;
  background-color: ${colors.blue1};
  color: ${colors.whiteText};

  &:enabled {
    &:hover,
    &:focus,
    &:active {
      background-color: ${colors.blue8};
    }
  }

  &[disabled] {
    background-color: ${colors.disabledBlue};
  }
`;

export const ButtonSecondaryOutlinedGray = styled(BaseButton)`
  background-color: ${colors.white};
  color: ${colors.lightGray2};
  border-color: ${colors.lightGray21};

  &:enabled {
    &:hover,
    &:focus {
      color: ${colors.blue1};
      border-color: ${colors.blue1};
    }
    &:active {
      background-color: ${colors.blue1};
      color: ${colors.white};
    }
  }

  &[disabled] {
    color: ${colors.lightGray2};
  }
`;

export const ButtonSecondaryOutlinedBlue = styled(BaseButton)`
  background-color: ${colors.white};
  color: ${colors.blue1};
  border-color: ${colors.blue1};

  &:enabled {
    &:hover,
    &:focus {
      background-color: ${colors.activeInputGray};
    }
    &:active {
      background-color: ${colors.blue1};
      color: ${colors.white};
    }
  }

  &[disabled] {
    color: ${colors.lightGray2};
    border-color: ${colors.lightGray1};
  }
`;

export const BackLinkButton = styled(Link)`
  background-color: ${colors.white};
  text-decoration: none;
  color: ${colors.blue1};
  border: 1px solid ${colors.blue1};
  border-radius: 3px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Roboto, sans-serif;
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
  text-align: center;
  transition: 200ms;

  &:hover {
    text-decoration: none;
  }

  &:enabled {
    &:hover,
    &:focus {
      background-color: ${colors.activeInputGray};
    }
    &:active {
      background-color: ${colors.blue1};
      color: ${colors.white};
    }
  }

  &[disabled] {
    color: ${colors.lightGray2};
    border-color: ${colors.lightGray1};
  }

  @media screen and (max-width: ${breakpoints.maxTablet}) {
    height: 40px;
  }
`;
